import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddDesignation from "./addDesignation";
import GetAllDesignation from "./getAllDesignation";
import UploadMany from "../Card/UploadMany";

const Designation = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  const refreshList = () => {
    setAddModalOpen(false);
    setUploadModalOpen(false);
    setRefreshKey((k) => k + 1);
  };

  const addButton = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setAddModalOpen(true)}
      style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", fontWeight: 600 }}
    >
      Add Designation
    </Button>
  );

  const uploadButton = (
    <Button
      type="default"
      icon={<UploadOutlined />}
      onClick={() => setUploadModalOpen(true)}
    >
      Import from CSV
    </Button>
  );

  return (
    <div>
      <Modal
        title="Add Designation"
        open={addModalOpen}
        onCancel={() => setAddModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <AddDesignation inModal onSuccess={refreshList} onCancel={() => setAddModalOpen(false)} />
      </Modal>
      <Modal
        title="Import from CSV"
        open={uploadModalOpen}
        onCancel={() => setUploadModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <UploadMany urlPath="designation" onSuccess={refreshList} />
      </Modal>
      <GetAllDesignation refreshTrigger={refreshKey} addDesignationButton={addButton} uploadButton={uploadButton} />
    </div>
  );
};

export default Designation;
